import { render, staticRenderFns } from "./enewsList.vue?vue&type=template&id=75447226&scoped=true&lang=html&"
import script from "./enewsList.vue?vue&type=script&lang=js&"
export * from "./enewsList.vue?vue&type=script&lang=js&"
import style0 from "./enewsList.vue?vue&type=style&index=0&id=75447226&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75447226",
  null
  
)

export default component.exports